export class DOutDescription {
  number: number;
  description: string;
  department: string;

  constructor() {
    this.number = 0;
    this.description = "-- not in use --";
    this.department = "";
  }
}

export interface DigitalOutDescription {
  DO: DOutDescription[];
}
